export interface ComingSoonPageConfig {
  featureName: string;
  description: string;
  /** Replace per page under assets/img/coming-soon/ */
  backgroundImageSrc: string;
}

/** Page-specific coming soon copy and background images (swap images in assets/img/coming-soon/). */
export const COMING_SOON_CONFIG = {
  configuration: {
    featureName: 'Configuration Management',
    description:
      "In an upcoming release, you'll be able to manage device configurations and deployment workflows from a single portal.",
    backgroundImageSrc: 'assets/img/coming-soon/bg-configuration.png',
  },
  diagnostics: {
    featureName: 'Diagnostics & Remediation',
    description:
      "In an upcoming release, you'll be able to run remote diagnostics, view DTCs, and remediate device issues across your fleet.",
    backgroundImageSrc: 'assets/img/coming-soon/bg-diagnostics.png',
  },
  reports: {
    featureName: 'Operational Intelligence & Reports',
    description:
      "In an upcoming release, you'll be able to access fleet analytics, custom reports, and operational intelligence dashboards.",
    backgroundImageSrc: 'assets/img/coming-soon/bg-reports.png',
  },
  deviceSimNetwork: {
    featureName: 'SIM / Network',
    description:
      "In an upcoming release, you'll be able to view SIM status, manage network actions, and monitor connectivity activity.",
    backgroundImageSrc: 'assets/img/coming-soon/bg-device-sim-network.png',
  },
  deviceDigitalTwin: {
    featureName: 'Device Digital Twin',
    description:
      "In an upcoming release, you'll be able to view static and dynamic configuration details and command history.",
    backgroundImageSrc: 'assets/img/coming-soon/bg-device-digital-twin.png',
  },
} as const satisfies Record<string, ComingSoonPageConfig>;
